import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'StyleCore',
  brandName: 'StyleCore',
  description: 'Sistema de agendamento para cabeleireiros',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Salão de cabeleireiro moderno',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Cabeleireira cortando cabelo',
  },
  testimonials: [
    {
      name: 'Sónia Pereira',
      role: 'Hairstylist',
      text: 'O StyleCore é o meu assistente pessoal! Ajuda-me a gerir todos os meus clientes e marcações sem esforço.',
      image: testimonial1,
    },
    {
      name: 'Ana Filipa',
      role: 'Cliente',
      text: 'Marcar o meu corte de cabelo nunca foi tão fácil. Adoro a conveniência de o fazer online.',
      image: testimonial2,
    },
    {
      name: 'Espaço Glamour',
      role: 'Gerente do Salão',
      text: 'Desde que adotámos o StyleCore, as falhas diminuíram 60%. Uma ferramenta essencial para qualquer salão.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'cabeleireiro',
    professionals: 'cabeleireiros',
    business: 'salão',
    businesses: 'salões',
    service: 'corte',
    services: 'cortes',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'marcação',
    appointments: 'marcações',
  },
  homepage: {
    hero: {
      badge: 'Hair Styling',
      title: 'Transforme estilos com StyleCore',
      description: 'Gerencie seus cortes e penteados, criando experiências únicas para seus clientes com o StyleCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '450+', label: 'Cabeleireiros' },
      { value: '42k+', label: 'Cortes Realizados' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Agenda Descontrolada',
        description: 'Gerir horários de múltiplos serviços e durações diferentes causa confusão na agenda.',
        icon: 'Scissors',
        quote: {
          text: 'Antes do StyleCore perdia 2 horas diárias só para organizar cortes, colorações e penteados',
          author: 'Ricardo Santos',
          business: 'Hair & Style Studio',
        },
      },
      {
        title: 'Clientes Sem Comparecer',
        description: 'Faltas sem aviso deixam períodos vagos e afetam a receita do salão.',
        icon: 'Users',
        stats: [
          { label: 'Taxa de faltas sem sistema:', value: '20%' },
          { label: 'Perda mensal de receita:', value: '750€+' },
        ],
      },
      {
        title: 'Histórico de Tratamentos',
        description: 'Sem registo digital, é difícil lembrar dos tratamentos anteriores e preferências dos clientes.',
        icon: 'FileText',
        quote: {
          text: 'Com o histórico de cortes consigo personalizar cada serviço e fidelizar mais clientes',
          author: 'Mariana Oliveira',
          business: 'Glamour Hair Salon',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'StyleCore: O seu assistente de estilo',
      description: 'Tecnologia criada para cabeleireiros que querem oferecer experiências memoráveis.',
      features: [
        {
          title: 'Agendamento por Serviço',
          description: 'Clientes escolhem cortes, colorações ou penteados com tempo adequado para cada serviço.',
        },
        {
          title: 'Perfil de Cliente',
          description: 'Mantenha histórico completo de todos os cortes, cores e tratamentos de cada cliente.',
        },
        {
          title: 'Lembretes de Retoque',
          description: 'Notifique automaticamente quando é hora de retocar a cor ou aparar.',
        },
      ],
    },
    testimonials: {
      title: 'O que os cabeleireiros dizem',
      description: 'Cabeleireiros que confiam no StyleCore para gestão profissional.',
    },
    finalCta: {
      title: 'Pronto para revolucionar seu salão?',
      description: 'Junte-se aos cabeleireiros que já transformaram sua gestão com o StyleCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de cabeleireiro',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
